import {useAppSelector} from "../../store/hooks";
import {isRegistrationWizardFlowActive} from "../state/registration_flow_slice";

export const useIsRegistrationWizardFlowActive = (): boolean => useAppSelector((state) => isRegistrationWizardFlowActive(state.registrationFlow));
import {useAppSelector} from "../../store/hooks";
import {isRegistrationWizardFlowActive} from "../state/registration_flow_slice";

export const useIsRegistrationWizardFlowActive = (): boolean => useAppSelector((state) => isRegistrationWizardFlowActive(state.registrationFlow));
